<template>
  <header class="page-header container-fluid w-100 p-0">
    <div class="header-wrapper row align-items-center py-4 no-gutters">
      <div class="col-12 col-md-8 flex-unordered text-center">
        <div class="row justify-content-end no-gutters">
          <div class="col-md-6">
            <a
              href="/daily"
              class="logo"
              title="Paul Smith"
              @click.prevent.stop="changeView('daily')"
            >
              <img src="./../assets/img/logo.svg" alt="Paul Smith Logo">
            </a>
          </div>
        </div>
      </div>

      <div class="mt-3 flex-last w-100 nav-wrapper">
        <nav class="shop-menu" role="navigation">
          <div
            class="shop-menu-item"
            v-for="(item, index) in pageData"
            :key="index"
            @click.prevent.stop="changeView(item.name)"
          >
            <a
              :href="item.name"
              :class="{ active: $route.params.id == item.name }"
            >
              {{ item.name }}
            </a>
          </div>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import { eventBus } from "./../main.js";

export default {
  props: ["pageData"],
  methods: {
    changeView(view) {
      eventBus.$emit("viewChanged", view);
    }
  }
};
</script>

<style lang="scss">
  .shop-menu-item {
    a.active {
      &::after {
        transform: scaleX(1);
      }
    }
  }
</style>

<style lang="scss" scoped>
  .nav-wrapper {
    height: auto;
    left: auto;
    opacity: 1;
    overflow: auto;
    position: relative;
    visibility: visible;
  }

  .shop-menu {
    text-align: center;
  }

  .shop-menu-item {
    border: 0;
    display: inline-block;
    left: auto;
    opacity: 1;
    transform: none;
    visibility: visible;

    a {
      cursor: pointer;
      font-weight: 400;
      font-size: 0.75rem;
      margin: 0 1.25rem;
      padding: 0.6875rem 0;
      position: relative;
      text-transform: uppercase;

      &::after {
        border-bottom: 1px solid #191919;
        content: '';
        display: block;
        margin-top: calc(0.6875rem - 1px);
        position: absolute;
        transform: scaleX(0);
        transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
        width: 100%;
      }

      &.active::after {
        transform: scaleX(1);
      }
    }
  }
</style>
